import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { AccountDateFilterRequest } from '../../../_shared/models/accountDateFilter.model';
import { environment } from '../../../../environments/environment';
import { PaginationRequest } from '../../../_shared/models/pagination-request.model';
import { OperationSummary } from '../models/operation-summary.model';
import { UtilizationTimeSeries } from '../models/operation-utilization.model';
import { OperationStatusDetail } from '../models/operation-status-detail.model';
import { Pagination, Response } from '../../../_shared/models';
import { OperationStatus } from '../models/operation-status.model';
import { OvertimeInsights } from '../models/overtime-insights.model';
import { OperationFrequentStops } from '../models/operation-frequent-stops.model';

@Injectable({
  providedIn: 'root'
})
export class DriverOperationsService {

  constructor(private http: HttpClient) { }

  public getDriverInVehicleStatus(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OperationStatus[]>>> {
    return firstValueFrom(this.http.post<Response<Pagination<OperationStatus[]>>>(`${environment.apiEndpoint}/DriverStatus/in-vehicle`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverInVehicleSummary(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OperationSummary>> {
    return firstValueFrom(this.http.post<Response<OperationSummary>>(`${environment.apiEndpoint}/driverstatus/summary/in-vehicle`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverStatusDetail(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OperationStatusDetail[]>>> {
    return firstValueFrom(this.http.post<Response<Pagination<OperationStatusDetail[]>>>(`${environment.apiEndpoint}/driverstatus/drivers-status-details`, request).pipe(takeUntil(cancellation)));
  }

  public getDriversEnRouteSummary(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OperationSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/summary/en-route`, request).pipe(takeUntil(cancellation)));
  }

  public getDriversEnRoute(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OperationStatus[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/en-route`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverUtilizationTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<UtilizationTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverinsights/utilization-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriversInYard(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OperationStatus[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/DriverStatus/in-yard`, request).pipe(takeUntil(cancellation)))
  }

  public getDriversInYardSummary(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OperationSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/summary/in-yard`, request).pipe(takeUntil(cancellation)));
  }

  public getStationaryDriversSummary(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OperationSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/summary/stationary`, request).pipe(takeUntil(cancellation)));
  }

  public getStationaryDrivers(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OperationStatus[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/stationary`, request).pipe(takeUntil(cancellation)));
  }

  public getHightestOvertime(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<OvertimeInsights[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverinsights/overtime`, request).pipe(takeUntil(cancellation)));
  }

  public getFrequentStops(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OperationFrequentStops[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverinsights/frequent-stops`, request).pipe(takeUntil(cancellation)));
  }

  public getDriversLocation(request: PaginationRequest, cancellation: Subject<void>): Promise<Response<OperationStatusDetail[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverstatus/drivers-location`, request).pipe(takeUntil(cancellation)));
  }
}